<template>
  <ion-page>
    <ion-content class="white">
      <ion-header style="font-weight: bold" class="ion-margin-bottom ion-margin-top ion-text-center">認証コードを入力してください</ion-header>
      <div class="ion-padding">
        <div class="ion-padding-horizontal">
          <ion-label>メールに記載されている認証コードを入力して、メールアドレスの認証を完了させてください。</ion-label>
          <br/>
          <ion-label class="ion-margin-bottom">認証が完了すると、パスワード更新画面が表示されます。</ion-label>

          <required-input label="認証コード" class="ion-margin-top"></required-input>
          <ion-input
            id="verifyCode"
            v-model="verifyCode"
            type="text"
            name="verifyCode"
            placeholder="認証コードを入力"
            label-placement="stacked"
            fill="outline"
            mode="md"
            color="dark"
            :class="{ 'border-danger': (errors && errors.verifyCode)}"
          ></ion-input>
          <ion-text color="danger" v-if="errors && errors.verifyCode">{{ errors.verifyCode }}</ion-text>
          <ion-button class="ion-margin-top primary-button" expand="block" @click="registerSubmit">認証する ></ion-button>
          <br/>
          <ion-label class="ion-margin-bottom">24時間以内にメールアドレス確認が完了しない場合は、認証コードは無効となります。</ion-label>
        </div>
      </div>
    </ion-content>
    <ion-loading trigger="open-loading" :duration="3000" message="処理中..."></ion-loading>
  </ion-page>
</template>

<script setup lang="ts">
import { useForm, useFormErrors, useField } from 'vee-validate';
import * as yup from 'yup';
import {
  IonPage,
  IonHeader,
  IonContent,
  IonLoading,
  loadingController,
  LoadingOptions,
  IonLabel,
  IonText,
  IonInput,
  IonButton,
} from "@ionic/vue";

import RequiredInput from "@/components/RequiredInput.vue";
import request from '../../utils/Request'
import { Device } from '@capacitor/device';
import { useRoute, useRouter } from 'vue-router';
import { verifyOtpCode } from '@/actions/verify-otp-code'
import StorageService from '../../utils/StorageService'
import { usePushNotification } from '@/composables/usePushNotification'
import { setCapacitorCookie } from "@/helpers/cookie";

const { getToken, sendNotificationToken } = usePushNotification()
const router = useRouter()
const route = useRoute()
const emits = defineEmits(['form-submit'])

const schema = yup.object({
  verifyCode: yup.string()
    .required('認証コードをご入力ください'),
})

const formVerifyCode = useForm({
  validationSchema: schema
})

const { value: verifyCode } = useField<string>("verifyCode")

const errors = useFormErrors() as any;

async function registerSubmit() {
  const resp = await formVerifyCode.validate();

  if (resp.valid) {
    submitForm({verifyCode: formVerifyCode.values.verifyCode, formVerifyCode: formVerifyCode})
  }
}

async function submitForm (form: any) {
  const deviceInfo = await Device.getInfo()

  const response: any = await verifyOtpCode({
    is_forgot_password: true,
    email: route.query.email as string,
    code: formVerifyCode.values.verifyCode,
    device_uuid: await StorageService.get('deviceUuid'),
    dont_set_verified: true
  }).catch((err: any) => {
    if (err.response?.status == 422) {
      formVerifyCode.setErrors(err.response.data.errors)
    }
  })
  if (!response?.status) {
    return
  }
  if (response.data.is_logged) {
    // デバイストークンを送信
    const token = await getToken()
    await sendNotificationToken(token)
    console.log('デバイストークン送信 ログイン後')
    router.push({name: 'UpdateForgotPassword', query: {
        email: response.data?.user.email,
        code: formVerifyCode.values.verifyCode,
      }
    });
  }
}

async function createLoading(msg: string, duration?: number, spinner: LoadingOptions["spinner"] = "crescent") {
  return await loadingController.create({
      message: msg,
      duration: duration,
      spinner: spinner,
    })
}
</script>

<style scoped></style>
